import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { Guid, IApiLink, ITranslations } from "@/types"

export enum InvoicePositionType {
    single = "single",
    recurring = "recurring",
}

export enum InvoicePositionDistributionRule {
    allAssets = "allAssets",
    machineOnly = "machineOnly"
}
export interface IGetTenantInvoicePositionDto {
    id: Guid
    number: string
    description: ITranslations
    isRentalFee: boolean
    isMachineInsurance: boolean
    text?: ITranslations | null
    distributionRule: InvoicePositionDistributionRule
    links: IApiLink[]
}

export interface ICreateTenantInvoicePositionDto {
    number: string
    description: ITranslations
    distributionRule: InvoicePositionDistributionRule
    isRentalFee: boolean
    isMachineInsurance: boolean
    text?: ITranslations | null
}

export interface IUpdateTenantInvoicePositionDto {
    description: ITranslations
    text?: ITranslations | null
}

export default class TenantInvoicePosition {
    id: Guid
    number: string
    description: ITranslations
    isRentalFee: boolean
    isMachineInsurance: boolean
    text?: ITranslations | null
    distributionRule: InvoicePositionDistributionRule

    linkUpdate?: IApiLink

    constructor(dto: IGetTenantInvoicePositionDto) {
        this.id = dto.id
        this.number = dto.number
        this.description = dto.description
        this.isRentalFee = dto.isRentalFee
        this.isMachineInsurance = dto.isMachineInsurance
        this.text = dto.text
        this.distributionRule = dto.distributionRule
        this.linkUpdate = dto.links.find(lnk => lnk.entity === ApiLinkEntity.tenantSettingsInvoicePosition && lnk.rel === ApiLinkRel.update)
    }
}
